





















































































































































































































import { Component, Watch } from "vue-property-decorator";
import Header from "@/components/header/ULoginHeader.vue";
import Footer from "@/components/Footer.vue";
import CheckUserLogin from "@/utils/CheckUserLogin";
import { UpdateOrganizationUser, UpdateUser } from "@/api/lab-base-api-client";
import UsersApi from "@/services/UsersApi";
import OrganizationUsersApi from "@/services/OrganizationUsers";
import UgcsApi from "@/services/Ugcs";
import CTooltip from "@/components/CTooltip.vue";
import TooltipModule from "@/store/tooltip";
import dayjs from "dayjs";
import AuthModule from "@/store/auth";
import { generateFileReader } from "@/utils/Util";
import logger from "@/lib/log/logger";

@Component({
  components: {
    Header,
    Footer,
    CTooltip,
  },
})
export default class URegisterInfoEdit extends CheckUserLogin {
  // 各フォームの初期値
  private form: UpdateUser | UpdateOrganizationUser = {
    name: "",
    ugcUuid: "",
    detail: {
      uuid: "",
      fullName: "",
      birthday: "",
      prefecture: "",
      city: "",
    },
  };

  // プロフィール画像
  private image = [];

  // 入力、表示の日付
  private inputDate = "";

  // v-date-picker
  private activePicker: string | null = null;

  // v-menu v-model
  private menu = false;

  // プロフィール画像のurl
  private ugcUrl = "";

  private get isTooltipShow() {
    return TooltipModule.isShow;
  }

  // アカウントの取得
  private get me() {
    return AuthModule.me;
  }

  private async mounted() {
    await this.fetch();
  }

  // アカウント情報編集ページで表示するデータの取得
  @Watch("me")
  private async fetch() {
    if (this.form.detail && this.me) {
      this.ugcUrl = this.me.ugc?.url;
      this.form.name = this.me.name;
      this.form.detail.uuid = this.me.userDetailUuid;
      this.form.detail.fullName = this.me.userDetail?.fullName;

      this.form.detail.prefecture = this.me.userDetail?.prefecture;
      this.form.detail.city = this.me.userDetail?.city;

      if (this.me.userDetail && this.me.userDetail.birthday) {
        this.form.detail.birthday = dayjs(this.me.userDetail?.birthday).format("YYYY-MM-DD");
        this.inputDate = dayjs(this.form.detail.birthday).format("YYYYMMDD");
      }
    }
  }

  // date-pickerをchangeしたときに実行
  private changeDatePicker(date: Date) {
    this.inputDate = dayjs(date).format("YYYYMMDD");
    this.menu = false;
  }

  @Watch("menu")
  private async clickCalender() {
    setTimeout(() => {
      this.activePicker = "YEAR";
    });
  }

  private async submit() {
    // 日付変換
    if (this.form.detail) {
      this.form.detail.birthday = dayjs(this.inputDate).format("YYYY-MM-DD");
    }
    if (this.image && this.image.length === undefined) {
      const ugcRes = await this.createUgc();
      this.form.ugcUuid = ugcRes.uuid;
    }
    try {
      if (this.me?.roleId === 2) {
        await this.userProfile();
      } else {
        await this.organizationUserProfile();
      }
      this.$router.push({ name: "URegisterInfoEditComp" });
    } catch (err) {
      TooltipModule.commitIsShow(true);
      setTimeout(() => {
        TooltipModule.commitIsShow(false);
      }, 5000);
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
  }

  private async userProfile() {
    if (!this.me) {
      return;
    }
    await UsersApi.instance.updateUserByUuid(this.me.uuid, this.form);
  }

  private async organizationUserProfile() {
    if (!this.me) {
      return;
    }
    await OrganizationUsersApi.instance.updateOrganizationUserByUuid(this.me.uuid, this.form);
  }

  // UGC作成
  private async createUgc() {
    try {
      const ugcRes = await UgcsApi.instance.createUGC(this.image);
      if (ugcRes.data.data?.ugc?.uuid === undefined) {
        logger.frontError("failed create ugc");
        throw new Error("failed create ugc");
      }
      return ugcRes.data.data.ugc;
    } catch (err) {
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
      throw err;
    }
  }

  /**
   * v-file-inputで選択したimageのプレビューを表示
   * 公式でchangeイベントの型はFile[]だが、ここでは単一のファイルしか使用しないためFileとして定義する
   */
  private previewFile(file: File) {
    if (!file) {
      this.ugcUrl = "";
    }
    const reader = generateFileReader(file);
    if (reader) {
      reader.addEventListener("load", () => {
        if (reader.result instanceof ArrayBuffer) {
          this.ugcUrl = reader.result.toString();
        } else if (reader.result) {
          this.ugcUrl = reader.result;
        }
      });
    }
  }
}
